import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  h1 {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    svg {
      fill: ${({ theme }) => theme.colors.secondary};
      width: 3rem;
      height: 3rem;
      margin-right: 0.5rem;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
  gap: 1.5rem;
  .note {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    height: 100px;
    width: 100% !important;
    resize: none;
    font-family: 'Futura PT' !important;
    font-size: 1rem;
    padding: 0.5rem;
    border-radius: 0.5rem;
  }

  .note:focus {
    color: ${({ theme }) => theme.colors.text_gray};
    box-shadow: 0 0 0 0;
    outline: 0;
  }

  .note::placeholder {
    color: ${({ theme }) => theme.colors.text};
    font-size: 1rem;
  }
  .containerIntegratedProtocol {
    display: flex;
    align-items: center;
    h3 {
      color: ${({ theme }) => theme.colors.primary};
      margin-top: 0.4rem;
      white-space: nowrap;
      margin-right: 1.5rem;
    }
    h4 {
      color: ${({ theme }) => theme.colors.primary};
      padding-right: 1rem;
      white-space: nowrap;
    }
    .controllerYesNo {
      width: 4rem;
    }
  }
  .containerAttachment {
    display: flex;
    flex-direction: column;

    .contentAttachment {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .contentDropzone {
        display: flex;
        flex-direction: column;
        align-self: center;

        .attachments {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }
      }
    }
  }

  .content-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
